<section class="card-grid-panel" *ngIf="!!data" #panelElRef>
  <div class="card-grid-panel__content">
    <div class="card-grid-panel__title">
      <h2 *ngIf="data.title" class="card-grid-panel__title--main-title" #titleEl>{{ data.title.value }}</h2>
      <h3 *ngIf="data.subtitle" class="card-grid-panel__title--subtitle" #subtitleEl>{{ data.subtitle.value }}</h3>
    </div>

    <!-- TODO: change data.col.value to numbers -->
    <div
      *ngIf="data.items"
      class="card-grid-panel__grid"
      [ngClass]="{
        'card-grid-panel__one-col': data.col.value == 'One',
        'card-grid-panel__two-col': data.col.value == 'Two'
      }"
      #gridEl
    >
      <div
        *ngFor="let item of data.items.value; let i = index"
        class="card-grid-panel__grid-item"
        #cardsEl
      >
        <div class="card-grid-panel__items">
          <div class="card-grid-panel__header">
            <h2>{{ item.header?.value }}</h2>

            <img
              *ngIf="item.icon.value"
              src="{{ item.icon.value.src }}"
              alt="{{ item.icon.value.alt }}"
              loading="lazy"
              [ngStyle]="{aspectRatio: item.icon?.value?.width / item.icon?.value?.height}"
            />
          </div>
          <div
            class="card-grid-panel__descripton"
            [innerHTML]="item.description.value | safe"
          ></div>
        </div>
        <img
          *ngIf="item.image.value"
          src="{{ item.image.value.src }}"
          alt="{{ item.image.value.alt }}"
          loading="lazy"
          class="card-grid-panel__bottom-img"
          [ngStyle]="{aspectRatio: item.image?.value?.width / item.image?.value?.height}"
        />
      </div>
    </div>
    <div class="card-grid-panel__link" *ngIf="data.links && data.links?.value">
      <app-bg-button
        *ngFor="let link of data.links.value"
        [data]="link.link.value"
        [buttonColor]="link.color.value"
      ></app-bg-button>
    </div>
  </div>
</section>
